// "Destacar publicación" de autos y propiedades: el dueño paga un paquete
// por PayPal a Notiline y recordPayPalPayment (functions/payments.js) le
// pone featuredUntil a la publicación. Mientras no venza, los listados la
// muestran primero y con la etiqueta "Destacado".
// Mismos valores que FEATURE_PACKAGES en functions/payments.js.
export const FEATURE_PACKAGES = [
  { days: 7, price: 4.99 },
  { days: 30, price: 14.99 },
];

export const featuredUntilDate = (listing) => {
  const v = listing?.featuredUntil;
  if (!v) return null;
  const date = v.toDate ? v.toDate() : new Date(v.seconds ? v.seconds * 1000 : v);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const isFeatured = (listing) => {
  const until = featuredUntilDate(listing);
  return !!until && until > new Date();
};

// Orden estable: las destacadas adelante, el resto queda como estaba.
export const featuredFirst = (list) =>
  [...list].sort((a, b) => Number(isFeatured(b)) - Number(isFeatured(a)));
